/**

 * @作者 王

 * @创建于 2021/3/15 11:21

 */
export let BASE_IDS_URL = window.webConfig.baseApiPath + '/ids';
export let BASE_SYS_URL = window.webConfig.baseApiPath + '/system';
export let BASE_OSS_URL = window.webConfig.baseApiPath + '/oss';
export let BASE_BPM_URL = window.webConfig.baseApiPath + '/ids/bpm';
